import { render, staticRenderFns } from "./CustomDragPanel.vue?vue&type=template&id=4d20d2e2&scoped=true"
import script from "./CustomDragPanel.vue?vue&type=script&lang=js"
export * from "./CustomDragPanel.vue?vue&type=script&lang=js"
import style0 from "./CustomDragPanel.vue?vue&type=style&index=0&id=4d20d2e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20d2e2",
  null
  
)

export default component.exports